export default __webpack_public_path__ + "static/banner-happy-traveller-1e352851494194fe7080d956ed91b109.jpg";